module.exports = __webpack_public_path__ + "static/media/tutorial-03.602a85c1.jpg";